import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import vtourskin from "../assets/vtourskin.png";
import { useEffect, useRef, useState } from 'react';

const carousselTransitionTime = '0.3s';
const buttonIconsize = '45px';

function CameraPreviewsCaroussel ({ cameras, arePreviewsVisible, selectedCamera, setSelectedCamera, sx}) {
  const [startX, setStartX] = useState();  
  const [isGrabbed, setIsGrabbed] = useState(false);  
  const [didDrag, setDidDrag] = useState(false);
  const lastMousePosRef = useRef(-1);

  return (
  <Stack
    id='outerCaroussel'
    onPointerDown = { (e) => { 
      e.target.setPointerCapture(e.pointerId);

      let innerCaroussel = document.getElementById("innerCaroussel");
      let outerCaroussel = document.getElementById("outerCaroussel");
      let outer = outerCaroussel.getBoundingClientRect();
      let inner = innerCaroussel.getBoundingClientRect();

      if(outer.width > inner.width) {
        return;
      }

      const x = e.clientX - innerCaroussel.offsetLeft;
      innerCaroussel.style.transition = '';
      setStartX(x);
      setIsGrabbed(true); 
    } }
    onPointerUp = { (e) => { 
      setIsGrabbed(false);
      setDidDrag(false);
    } }
    onPointerMove = { (e)=> {
      let x = e.clientX;
      const oldLastPos = lastMousePosRef.current;
      lastMousePosRef.current = x;

      if(!isGrabbed) {
        return;
      }
      e.preventDefault();

      let innerCaroussel = document.getElementById("innerCaroussel");
      let outerCaroussel = document.getElementById("outerCaroussel");

      if(Math.abs(oldLastPos - lastMousePosRef.current) != 0) {
        setDidDrag(true); // This is annoying but mouse move is called on mouseclick. So needed
      }

      innerCaroussel.style.left = `${x - startX}px`;
      
      let outer = outerCaroussel.getBoundingClientRect();
      let inner = innerCaroussel.getBoundingClientRect();
    
      if (parseInt(innerCaroussel.style.left) > 0) {
        innerCaroussel.style.left = "0px";
      }
      if (inner.right < outer.right) {
        innerCaroussel.style.left = `-${inner.width - outer.width}px`;
      }
    } }
    sx={{
      overflow: 'hidden',
      position: 'relative',
      justifyContent: 'space-evenly',
      alignItems: 'center',
      paddingLeft: '5px',
      paddingRight: '5px',
      height: () => { return arePreviewsVisible ? '100px' : '0px' },
      width: '800px',
      transition: `bottom ${carousselTransitionTime}, height ${carousselTransitionTime} ease`,
      backgroundColor: 'rgba(40, 54, 70, 0.8)',
      ...sx
    }}
    >
    <Stack

      id='innerCaroussel'
      direction='row'
      spacing={1.5}
      sx={{
        display: 'flex',
        position: 'absolute',
        top: 0,
        left: 0,
        justifyContent: 'space-evenly',
        alignItems: 'center',
        height: () => { return arePreviewsVisible ? '100px' : '0px' },
        opacity: () => { return arePreviewsVisible ? 1 : 0 },
        padding:'6px',
        transition: 'bottom 0.3s, height 0.3s, opacity 0.2s',
        ...sx
      }}
      >
        {
        cameras.map( (c) => {
          const previewUrl = c['preview_url'] ? c.preview_url : c.image + '?w=800&quality=75';
          return (
              <Box
              key={c.name}
              onPointerUp = { (e) => { 
                if(didDrag) {
                  return;
                }
                setSelectedCamera(c.name);

                let outerCaroussel = document.getElementById("outerCaroussel");
                let innerCaroussel = document.getElementById("innerCaroussel");
                let mouseX = e.clientX;
                let outerCarousselRect = outerCaroussel.getBoundingClientRect();

                // Find which part of the inner caroussel should be in the middle of the container
                const mid = (outerCarousselRect.right + outerCarousselRect.left) / 2;
                const requiredXDelta =  mouseX - mid;
                const newLeft = innerCaroussel.offsetLeft - requiredXDelta;
                innerCaroussel.style.left = `${newLeft}px`;
                innerCaroussel.style.transition = 'left 0.5s ease';
                
                let inner = innerCaroussel.getBoundingClientRect();
                let outer = outerCaroussel.getBoundingClientRect();

                if (parseInt(innerCaroussel.style.left) > 0) {
                  innerCaroussel.style.left = "0px";
                }
                if ((newLeft + inner.width) <= outer.width) {
                  innerCaroussel.style.left = `-${inner.width - outer.width}px`;
                }
              } }
              sx={{
                height: '85px',
                width: '125px',
                border: c.name == selectedCamera ? 'white 3px solid' : '',
                background: `url(${previewUrl})`,
                backgroundPositionX: '30%',
                backgroundPositionY: '52%',
                backgroundSize: '400px'
              }}

            />
          )
        })}
    </Stack>
  </Stack>
  )
}

function BarButton ({Icon, dataTrackId='', dataTrackValue='', label, onClick, sx = {}}) {
  return (
    <Button
    data-track-id={dataTrackId}
    data-track-value={dataTrackValue}
    onClick={onClick}
    startIcon={Icon || undefined}
    sx={{
      height: buttonIconsize,
      width: buttonIconsize,
      minWidth: '0px',
      transform: 'scale(0.8)',
      '&:after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: '100%',
        height: '100%',
        background: 'radial-gradient(#99999999, #00000000)',
        borderRadius: '50%',
        transition: 'opacity 0.1s',
        transform: 'translate(-50%, -50%)',
        opacity: 0,
      },
      '&:hover:after': {
        width: '200%',
        height: '150%',
        opacity: 0.5,
      },
      ...sx,
    }}
  ></Button>
  )
}

function BarSpacer () {
  return (
    <Box sx={{ position: 'relative', backgroundColor: 'transparent', width:buttonIconsize, height:buttonIconsize}}/>
  )
}

function VTControlsBarContainer ({children, cameras, isMinimized, setIsMinimized,
  arePreviewsVisible, setArePreviewsVisible, delayedShowControls, selectedCamera, setSelectedCamera, sx = {}}) {
 const barHeight = '40px';  
 return (
    <Stack
     position={'absolute'}
     direction='column'
     width={'100%'}
     sx={{
       flexWrap: 'wrap',
       alignContent: 'center',
       bottom: `${isMinimized ? '-100px' : '19px' }`,
       transition: 'bottom 1s ease',
       transitionDelay: `${!arePreviewsVisible ? '0.3s' : '0s' }`
     }}
    >
    {/* Little maximize arrow widget */}
    <Box
      onClick={ () => { 
        const newMinimizedVal = !isMinimized;
        setIsMinimized(newMinimizedVal);
        setArePreviewsVisible(false);
      } }
      sx={{
        position: 'absolute',
        bottom: `${isMinimized ? '110px' : '-200px' }`,
        width: '0px',
        height: '0px',
        padding: '0px',
        alignSelf: 'center',
        borderLeft: '12px solid transparent',
        borderRight: '12px solid transparent',
        borderBottom: '14px solid #EAEAEACC',
        minWidth: '0px',
        zIndex: '10',
        transition: 'bottom 2s',
        transitionDelay: `${arePreviewsVisible ? '0s' : '0s' }`,
        '&:hover': {
          borderBottom: '14px solid #E0E0E0EE',
        },
        '&::after': {
          position: 'absolute',
          content: "''",
          left: '-200px',
          width: 'calc(100% + 400px)',
          height: 'calc(100% + 40px)'
        },
      }}
    />
    {/* The bar and the preview rows */}
      <Stack
        className={delayedShowControls ? 'delayed-open' : (isMinimized ? 'minimized' : '')}
        sx={{
          position: 'relative',
        }}
      >
        <Box
          sx={{
            color: 'white',
            fontFamily: 'arial',
            fontSize: '12px',
            fontStyle: 'italic',
            textShadow: '1px 1px 2px black',
          }}
        >
          {selectedCamera}
        </Box>
        <Stack
            sx={{
              boxShadow: '0px 10px 6px 6px rgb(0, 0, 0, 0.1)',
            }}
          >
          {/* Preview Rows */}
          <CameraPreviewsCaroussel cameras={cameras} arePreviewsVisible={arePreviewsVisible} isMinimized={isMinimized} selectedCamera={selectedCamera} setSelectedCamera={setSelectedCamera}/>
          {/* Control Bar */}
          <Stack
            direction='row'
            spacing={1.5}
            sx={{
              position: 'relative',
              paddingLeft: '5px',
              paddingRight: '5px',
              width: '800px',
              height: barHeight,
              justifyContent: 'space-evenly',
              alignItems: 'center',
              backgroundColor: 'rgba(40, 54, 70, 0.8)',
              ...sx
            }}
          >
            {children} {/* <------- Bar buttons go here */}
          </Stack>
      </Stack>
    </Stack>
   </Stack>
 )
}

export function VTControlBar ({cameras, animationStyle, isMinimized, setIsMinimized, arePreviewsVisible, setArePreviewsVisible, delayedShowControls, sx = {}}) {
  const activeCamera = window.player?.scene?.cameras[0];
  const zoomingSensibility = 0.02;
  const [selectedCamera, setSelectedCamera] = useState();

  const setSelectedCameraCallback = (cameraName) => {
    setSelectedCamera(cameraName);
    window.player.moveToCamera(cameraName);
  }

  useEffect( () => {  // eslint-disable-line react-hooks/exhaustive-deps
    if(!window.player?.panoData?.cameras) {
      return;
    }
    if(!selectedCamera && cameras.length) {
      const initCameraName = window.player?.getStartCameraName() || cameras[0].name;
      setSelectedCameraCallback(initCameraName);
      return;
    }
    if(selectedCamera && window.player?.currCameraInfo.name != selectedCamera && !window.player?.isMoving) {
      const nextCamera = window.player?.currCameraInfo.name ?? selectedCamera; // We might be moving by clicking on the 360 view. Update state with player data
      
      setSelectedCamera(nextCamera);
      return;
    }
  })

  return (
    <VTControlsBarContainer
      delayedShowControls={delayedShowControls}
      cameras={cameras ?? []}
      isMinimized={isMinimized}
      arePreviewsVisible={arePreviewsVisible}
      setArePreviewsVisible={setArePreviewsVisible}
      animationStyle={animationStyle}
      setIsMinimized={setIsMinimized}
      selectedCamera={selectedCamera}
      setSelectedCamera={setSelectedCameraCallback}
    >
      {/* Previous Camera */}
      <BarButton
        dataTrackId='NavBarPrevCamera'
        dataTrackValue='NavBar Prev Camera'
        Icon= {
          <Box
            position={'relative'}
            width={'69px'}
            height={buttonIconsize}
            sx={{
                left: '5px',
                background: `url(${vtourskin})`,
                transform:'scale(0.65)',
                backgroundPosition: '-4% 10%',
              }}
          />
        }
        onClick={ () => {
          if(!selectedCamera) {
            setSelectedCameraCallback(cameras[0].name);
            return;
          }

          let currentCamIndex = cameras.findIndex( (c) => {
            return c.name == selectedCamera;
          });
          const nextCamIndex = (currentCamIndex - 1) % (cameras.length + 1);
          setSelectedCameraCallback(cameras[nextCamIndex].name);
        }}
      />
      {/*Previews*/}
      <BarButton
        dataTrackId='NavBarPreviews'
        dataTrackValue='NavBar Previews'
        Icon= {
          <Box
            position={'relative'}
            width={'69px'}
            height={buttonIconsize}
            sx={{
                left: '5px',
                background: `url(${vtourskin})`,
                transform:'scale(0.7)',
                backgroundPosition: '-4% 19%',
              }}
          />
        }
        onClick={ () => {
          setArePreviewsVisible(!arePreviewsVisible);
        }}
      />
      {/*Hotspots and cursor*/}
      <BarButton
        dataTrackId='NavBarHotspots'
        dataTrackValue='NavBar Hotspots'
        Icon= {
          <Box
            position={'relative'}
            width={'69px'}
            height={buttonIconsize}
            sx={{
                left: '5px',
                background: `url(${vtourskin})`,
                transform:'scale(0.75)',
                backgroundPosition: '-6% 54.5%',
              }}
          />
        }
        onClick={ () => {
          window.player.setNavigationElementsVisible(!window.player.getNavigationElementsVisible());
        }}
      />
      <BarSpacer/>
      <BarSpacer/>
      <BarSpacer/>
      {/* Left arrow */}
      <BarButton
        dataTrackId='NavBarLeftArrow'
        dataTrackValue='NavBar Left Arrow'
        Icon= {
          <Box
            position={'relative'}
            width={buttonIconsize}
            height={buttonIconsize}
            sx={{
                background: `url(${vtourskin})`,
                transform:'scale(0.65)',
                backgroundPosition: '0% 27.5%',
              }}
          />
        }
        onClick={ () => {
          activeCamera.inertialAlphaOffset  += zoomingSensibility;
        }}
      />
      {/* Right arrow */}
      <BarButton
        dataTrackId='NavBarRightArrow'
        dataTrackValue='NavBar Right Arrow'
        Icon= {
          <Box
            position={'relative'}
            width={buttonIconsize}
            height={buttonIconsize}
            sx={{
                background: `url(${vtourskin})`,
                transform:'scale(0.65)',
                backgroundPosition: '81% 27.5%',
              }}
          />
        }
        onClick={ () => {
          activeCamera.inertialAlphaOffset -= zoomingSensibility;
        }}
      />
      {/* Up arrow */}
      <BarButton
        dataTrackId='NavBarUpArrow'
        dataTrackValue='NavBar Up Arrow'
        Icon= {
          <Box
            position={'relative'}
            width={buttonIconsize}
            height={buttonIconsize}
            sx={{
              background: `url(${vtourskin})`,
              transform:'scale(0.65)',
              backgroundPosition: '0% 36.5%',
          }}
          />
        }
        onClick={ () => {
          activeCamera.inertialBetaOffset += zoomingSensibility;
        }}
      />
      {/* Down arrow */}
      <BarButton
        dataTrackId='NavBarDownArrow'
        dataTrackValue='NavBar Down Arrow'
        Icon= {
          <Box
            position={'relative'}
            width={buttonIconsize}
            height={buttonIconsize}
            sx={{
                background: `url(${vtourskin})`,
                transform:'scale(0.65)',
                backgroundPosition: '81% 36.5%',
              }}
          />
            
        }
        onClick={ () => {
          activeCamera.inertialBetaOffset -= zoomingSensibility;
        }}
      />
      {/* + arrow */}
      <BarButton
        dataTrackId='NavBarPlus'
        dataTrackValue='NavBar Plus'
        Icon= {
          <Box
            position={'relative'}
            width={buttonIconsize}
            height={buttonIconsize}
            sx={{
                background: `url(${vtourskin})`,
                transform:'scale(0.65)',
                backgroundPosition: '0% 45.5%',
              }}
          />
        }
      />
      {/* - icon */}
      <BarButton
        dataTrackId='NavBarMinus'
        dataTrackValue='NavBar Minus'
        Icon= {
          <Box
            position={'relative'}
            width={buttonIconsize}
            height={buttonIconsize}
            sx={{
                left: '3px',
                background: `url(${vtourskin})`,
                transform:'scale(0.65)',
                backgroundPosition: '81% 45.5%',
              }}
          />
            
        }
      />
      {/* VR icon */}
      <BarSpacer/>
      <BarSpacer/>
      <BarSpacer/>
      <BarSpacer/>
      <BarSpacer/>
      {/* Minimize icon */}
      <BarButton
        dataTrackId='NavBarMinimiseIcon'
        dataTrackValue='NavBar Minimise Icon'
        Icon= {
          <Box
            position={'relative'}
            width={'68px'}
            height={buttonIconsize}
            sx={{
                paddingRight: '50px',
                left: '7px',
                background: `url(${vtourskin})`,
                transform:'scale(0.65)',
                backgroundPosition: '0% 63.5%',
              }}
          />
        }
        onClick={() => {
          setArePreviewsVisible(false);
          setIsMinimized(true);
        }}
      />
      {/* Next camera */}
      <BarButton
        dataTrackId='NavBarNextCamera'
        dataTrackValue='NavBar Next Camera'
        Icon= {
          <Box
            position={'relative'}
            width={'68px'}
            height={buttonIconsize}
            sx={{
                paddingRight: '50px',
                left: '5px',
                background: `url(${vtourskin})`,
                transform:'scale(0.65)',
                backgroundPosition: '100% 10%',
              }}
          />
        }
        onClick={ () => {
          if(!selectedCamera) {
            setSelectedCameraCallback(cameras[0].name);
            return;
          }

          let currentCamIndex = cameras.findIndex( (c) => {
            return c.name == selectedCamera;
          });
          const nextCamIndex = (currentCamIndex + 1) % (cameras.length + 1);
          setSelectedCameraCallback(cameras[nextCamIndex].name);
        }}
      />
    </VTControlsBarContainer>
  )
}



